import { render, staticRenderFns } from "./CustomerDocumentGallery.vue?vue&type=template&id=e6c31200"
import script from "./CustomerDocumentGallery.vue?vue&type=script&lang=js"
export * from "./CustomerDocumentGallery.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocumentGallery.vue?vue&type=style&index=0&id=e6c31200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports